/* PoCichu - powiekszanie filmow.
   Mala ikonka w prawym dolnym rogu kafelkow karuzeli UGC (.pc-mtile) i filmu
   "Jak to dziala" (.pc-film) otwiera film w nakladce: ciemne tlo, kadr 9:16
   wysrodkowany, natywne kontrolki. NIE uzywamy requestFullscreen - natywny
   pelny ekran rozciaga pion 9:16 na monitor 16:9 i przycina kadr.
   Odtwarzanie w miejscu zostaje bez zmian. Osobny plik: nie ruszamy sekcji z trescia. */
(function () {
  'use strict';

  var CSS =
    '.pcfs-wrap{position:relative;line-height:0}' +
    '.pcfs{position:absolute;right:6px;bottom:6px;z-index:5;width:27px;height:27px;padding:0;' +
      'border-radius:8px;border:1px solid rgba(255,255,255,.4);background:rgba(0,0,0,.5);color:#fff;' +
      'display:flex;align-items:center;justify-content:center;cursor:pointer;' +
      '-webkit-tap-highlight-color:transparent;transition:background .15s}' +
    '.pcfs:hover{background:rgba(0,0,0,.75)}' +
    '.pcfs:focus-visible{outline:2px solid #fff;outline-offset:1px}' +
    '.pc-film .pcfs{right:10px;bottom:10px;width:32px;height:32px;border-radius:9px}' +
    '@media(max-width:749px){.pcfs{width:30px;height:30px}}' +
    '.pcfs-ov{position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.93);' +
      'display:none;align-items:center;justify-content:center;padding:16px}' +
    '.pcfs-ov.on{display:flex}' +
    '.pcfs-ov video{max-height:88vh;max-width:94vw;width:auto;height:auto;display:block;' +
      'object-fit:contain;border-radius:14px;background:#000;position:static;inset:auto}' +
    '.pcfs-x{position:absolute;top:14px;right:14px;width:40px;height:40px;padding:0;' +
      'border-radius:50%;border:1px solid rgba(255,255,255,.35);background:rgba(0,0,0,.55);' +
      'color:#fff;font-size:19px;line-height:1;display:flex;align-items:center;' +
      'justify-content:center;cursor:pointer;z-index:2}' +
    '.pcfs-x:hover{background:rgba(0,0,0,.85)}';

  var ICON =
    '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" ' +
    'stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5"/></svg>';

  var ov = null, ovVid = null, scrollLock = '';

  function addCss() {
    if (document.getElementById('pcfs-css')) return;
    var s = document.createElement('style');
    s.id = 'pcfs-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function buildOverlay() {
    if (ov) return ov;
    ov = document.createElement('div');
    ov.className = 'pcfs-ov';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'pcfs-x';
    x.setAttribute('aria-label', 'Zamknij');
    x.innerHTML = '&#10005;';
    x.addEventListener('click', function () { close(); });
    ov.appendChild(x);
    ov.addEventListener('click', function (e) {
      if (e.target === ov) close();
    });
    document.body.appendChild(ov);
    return ov;
  }

  function pauseAllTiles() {
    var all = document.querySelectorAll('.pc video');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].hasAttribute('autoplay')) all[i].pause();
    }
  }

  function open(src) {
    if (!src) return;
    buildOverlay();
    close(true);
    pauseAllTiles();

    ovVid = src.cloneNode(true);
    ovVid.removeAttribute('class');
    ovVid.removeAttribute('style');
    ovVid.removeAttribute('loop');
    ovVid.setAttribute('controls', '');
    ovVid.setAttribute('playsinline', '');
    ovVid.setAttribute('preload', 'auto');
    ovVid.muted = false;
    ovVid.controls = true;
    ov.appendChild(ovVid);

    ov.classList.add('on');
    scrollLock = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';

    try { ovVid.load(); } catch (e) {}
    var p = ovVid.play();
    if (p && p.catch) p.catch(function () {});
  }

  function close(silent) {
    if (!ov) return;
    if (ovVid) {
      try { ovVid.pause(); } catch (e) {}
      if (ovVid.parentNode) ovVid.parentNode.removeChild(ovVid);
      ovVid = null;
    }
    if (!silent) {
      ov.classList.remove('on');
      document.documentElement.style.overflow = scrollLock;
    }
  }

  function makeBtn(vid) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pcfs';
    b.setAttribute('aria-label', 'Powieksz nagranie');
    b.title = 'Powieksz';
    b.innerHTML = ICON;
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      open(vid);
    });
    return b;
  }

  function attach() {
    addCss();

    var tiles = document.querySelectorAll('.pc-mtile');
    for (var i = 0; i < tiles.length; i++) {
      (function (tile) {
        if (tile.querySelector('.pcfs')) return;
        var slot = tile.querySelector('.pc-mslot');
        var vid = tile.querySelector('video');
        if (!slot || !vid) return;
        var wrap = tile.querySelector('.pcfs-wrap');
        if (!wrap) {
          wrap = document.createElement('div');
          wrap.className = 'pcfs-wrap';
          slot.parentNode.insertBefore(wrap, slot);
          wrap.appendChild(slot);
        }
        wrap.appendChild(makeBtn(vid));
      })(tiles[i]);
    }

    var films = document.querySelectorAll('.pc-film');
    for (var j = 0; j < films.length; j++) {
      (function (film) {
        if (film.querySelector('.pcfs')) return;
        var vid = film.querySelector('video');
        if (!vid) return;
        film.appendChild(makeBtn(vid));
      })(films[j]);
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ov && ov.classList.contains('on')) close();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
  document.addEventListener('shopify:section:load', attach);
})();
